export { default as AlertsTable } from './AlertsTable'
